
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.6","d":"M5 27.19V2.81h15l5 5v19.38H5z"}}),_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M15 3.13h-1.87V5H15V3.13zM16.88 5H15v1.88h1.88V5zM15 6.88h-1.87v1.87H15V6.88zM16.88 8.75H15v1.88h1.88V8.75zM15 10.63h-1.87v1.87H15v-1.87zM16.88 12.5H15v1.88h1.88V12.5zM15 14.38h-1.87v1.87H15v-1.87z"}})]),_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2"}},[_c('path',{attrs:{"d":"M13.12 17.5h3.75v5.63h-3.75zM13.12 19.37h3.75"}})])])
          )
        }
      }
    